/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { useState, useEffect, Fragment as _ } from 'react';

export const InputText = ({
  width,
  height,
  placeholder = '',
  focusColor = '#000',
  callback = (value: String) => {},
}) => {
  const [value, setValue] = useState('');
  const [hasFocus, setHasFocus] = useState(false);

  useEffect(() => {
    callback(value);
  }, [value]);

  return (
    <div
      css={css({
        position: 'relative',
        width,
        height,
      })}
    >
      {!hasFocus && (
        <div
          className="data-input-blur-value-display"
          css={css({
            position: 'absolute',
            width,
            overflow: 'hidden',
            // for textarea
            height: '100%',
          })}
        >
          {value}
        </div>
      )}

      <textarea
        css={css({
          all: 'unset',
          position: 'relative',
          width,
          opacity: !value || hasFocus ? 1 : 0,
          height: '100%',
          overflow: 'hidden',
          resize: 'none',
          whiteSpace: 'pre-wrap',

          ':focus': {
            all: 'unset',
            width,
            height: '100%',
            outline: `1px solid ${focusColor}`,
            border: 'transparent !important',
            overflow: 'hidden',
            resize: 'none',
          },
        })}
        placeholder={placeholder}
        onFocus={() => {
          setHasFocus(true);
        }}
        onBlur={() => {
          setHasFocus(false);
        }}
        onChange={e => {
          setValue(e.currentTarget.value);
        }}
        autoComplete="off"
      />
    </div>
  );
};
